module.exports = __webpack_public_path__ + "static/media/abstract.994e1c78.jpg";